<template>
  <dialog-drag
    :id="id"
    :ref='"dialog-" + id'
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
	class="dialog-drag-display"
  >
    <template v-slot:title>
      <!-- [S]  Popup title-->
      <v-card-title
        class="headline white--text"
        primary-titlea>
        {{$t('lbl.repositoryMatching.page_header')}}
      </v-card-title>
    </template>
    <template v-slot:button-close>
      <v-icon class="ma-2" small @click="removeDialog" color="white">fas fa-times</v-icon>
    </template>
    <v-card class="dialog-content">
      <!-- [S] Popup body -->
      <v-card-text class=" pt-0 pl-0 pr-0 pb-0">
        <div class="repository-section">
          <v-row v-for="(repos, index) in repository_arr" :key="'repo_row' + index" class="repository">
            <v-col v-for="repo in repos" :key="repo.id" cols="12" md="4" class="pt-0 pb-0">
              <v-checkbox
                v-model="repo.checked"
                :label="repo.text"
                class="repository-checkbox"
                color="#12083F"
                dense
                hide-details>
              </v-checkbox>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <!-- [E] Popup body -->
    </v-card>
    <v-row class="repository-matching-action-row">
        <v-col class="comm-header-col pb-0 pt-0" cols="12" md="8">
            <div class="btn-form-control">
              <v-btn class="create-layout-button btn-height-custom" color="#0082ba" @click="allCheck()">
                <v-icon x-small class="mr-2">fas fa-check</v-icon>{{$t('btn.repositoryMatching.allCheck')}}
              </v-btn>
              <v-btn class="execute-matching-button btn-height-custom" color="#0082ba"  @click="openDialog()">
                <v-icon x-small class="mr-2">fa fa-magic</v-icon>{{$t('btn.repositoryMatching.exeMatching')}}
              </v-btn>
            </div>
        </v-col>
        <v-col class="comm-header-col pb-0 pt-0 text-right" cols="12" md="4">
          <div class="btn-form-control">
            <v-btn class="file-upload-button btn-height-custom" color="#cd5f5f"  @click="removeDialog">
              <v-icon x-small class="mr-2">fas fa-times</v-icon>{{$t('btn.common.close')}}
            </v-btn>
          </div>
        </v-col>
    </v-row>
    <dialogWindow
      ref="checkCustomer"
      size="max"
      title="Check Customer List"
      detail="Please check customer List for Matching!!"
    >
    </dialogWindow>
    <dialogWindow
      ref="matchingConfirmDialog"
      @select-ok="removeDialog({id}); eventCb();"
      size="max"
      title="Execute Matching"
      detail= 'The matching process is executed successfully.'
      color="success"
    >
    </dialogWindow>
  </dialog-drag>
</template>

<script>
/* globals Store */
import { mapState } from "vuex";
import DialogDrag from "@/vue-dlb/components/vue-dialog-drag.vue";
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';

export default {
  components: {
    DialogDrag,
    dialogWindow
  },
  name: "repository-matching-dialog",
  // props: ['id', 'title', 'options', 'eventCb', 'closeDialog', 'dragStart', 'dragEnd'],
  props:{
    id: String,
    title: String,
    options: Object,
    eventCb: Function,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
  },

  computed: {
    ...mapState("matching", {
      custList: "custList",
      layoutPopopParam: "layoutPopopParam"
    }),
  },

  data(){
    return{
    repository_arr : [],
    repositories: [],
    cust: {
      header: ['ADMIN_YN','CUST_ID'],
      data: [{
        ADMIN_YN: '',
        CUST_ID: ''
      }]
    },
    insertExecuteMaster: {
      header: ['CUST_ID'],
      data: [{
        CUST_ID: ''
      }]
    },
    insertExecuteData: {
      header: ['ADMIN_YN', 'MSG_STD', 'MSG_ID', 'MSG_VER','LAY_PRCS_NO'],
      data: [{
        ADMIN_YN: '',
        MSG_STD: '',
        MSG_ID: '',
        MSG_VER: '',
        LAY_PRCS_NO: ''
      }]
    },
    selectedItem: [],
    checkflag: true
  }},

  created() {
    this.getCustomerList();
  },

  watch: {},

  methods: {
    removeDialog (dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
      this.$emit("select-close");
    },
    selectDialog (obj) {
      this.dragStart(obj);
    },
    dialogDragEnd (obj) {
        this.dragEnd(obj);
    },
    allCheck() {
      for (let i = 0; i < this.repositories.length; i++) {
        let repo = this.repositories[i];
        if (this.checkflag === false) {
          repo.checked = true;
        } else{
          repo.checked = false;
        }
      }
      if (this.checkflag === false) {
        this.checkflag = true;
      } else{
        this.checkflag = false;
      }
    },

    getCustomerList() {
      this.cust.data[0].ADMIN_YN = this.$cookies.get('match-used-repo');
      this.cust.data[0].CUST_ID = this.$cookies.get('comp-id');
      Store.dispatch("matching/getCustomerList", this.cust).then(() => {
        this.matchingCustomerCode();
        console.log("--------- Finished to process ----------");
      });
    },

    matchingCustomerCode() {

      //Test && Server
       for (var i = 0; i < this.custList.length; i++) {
         this.repositories[i] = {
           id: `${this.custList[i].ROWID}`,
           checked: true,
           text: `${this.custList[i].MST_CUST_NAME}`,
           value: `${this.custList[i].MST_CUST_ID}`
         }
      }

      let index = 0;
      while(index < this.repositories.length) {
        this.repository_arr.push(this.repositories.slice(index, index + 3));
        index += 3;
      }
    },
    async openDialog() {
      console.log("--------- execute matching ----------");
      this.selectedItem = [];
      //insertExecuteMaster
      for(let i = 0; i < this.repositories.length; i++) {
        if (this.repositories[i].checked != false) {
          this.selectedItem.push(this.repositories[i].value);
        }
      }

      if (this.selectedItem.length > 0) {
        for(let i = 0; i < this.selectedItem.length; i++) {
          this.insertExecuteMaster.data[i] ={
            CUST_ID: `${this.selectedItem[i]}`
          };
        }
        //insertExecuteData
        for(let i = 0; i < this.layoutPopopParam.data.length; i++) {
          this.insertExecuteData.data[i] = {
            ADMIN_YN: this.$cookies.get('match-used-repo'),
            MSG_STD: `${this.layoutPopopParam.data[i].MSG_STD}`,
            MSG_ID: `${this.layoutPopopParam.data[i].MSG_ID}`,
            MSG_VER: `${this.layoutPopopParam.data[i].MSG_VER}`,
            LAY_PRCS_NO: `${this.layoutPopopParam.data[i].LAY_PRCS_NO}`
          };
        }
        var insertPayload = [this.insertExecuteMaster, this.insertExecuteData];
        await Store.dispatch("layout/executeMatching", insertPayload).then(() => {
        });
        this.$refs.matchingConfirmDialog.dialog = true;
      } else {
         this.$refs.checkCustomer.dialog = true;
      }
    }
  }
};
</script>

<style>
.checkbox-row {
    margin: 0 0 0 8px;
}
.checkbox-row .v-input--selection-controls.v-input{
    width: 180px;
    height: 30px;
}
.checkbox-row .v-input--selection-controls {
    margin-top: 0px;
    padding-top: 0px;
    margin-bottom: 5px;
    padding-left: 16px;
}
.repository-matching-row_1{
    width: 592px;
    height: 160px;
    padding-top: 22px;

}
.repository-matching-row_2{
    width: 592px;
    height: 60px;
    padding-left: 38px;
}
.checkbox-row .v-icon.v-icon {
    font-size: 20px;
    color: #12083F;
}
.checkbox-row .v-label {
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 19px;
    display: flex;
    align-items: center;
    padding-left: 2px;
    color: #12083F;
}
.checkbox-row .v-input--selection-controls__ripple {
    width: 0px;
    height: 0px;
}

.repository-matching-action-row {
  margin-top: 10px;
}

.repository-checkbox .v-label.theme--light {
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  color: #12083F;
  margin-top: -2px;
}

.repository-checkbox .v-input--selection-controls__input i {
  color: #12083F;
}

.repository-checkbox.v-input--selection-controls.v-input {
  margin-top: 0px !important;
  padding-top: 0px !important;
}

.repository-section {
  height: 150px;
  overflow-y: auto;
  overflow-x: hidden;
}

</style>